import React from "react";
import InputRange from 'react-input-range';
import "react-input-range/lib/css/index.css";

const kgCo2PerCigarette = 0.014;

class Calculator extends React.Component {

  constructor(props) {
    super()
    this.state = {
      cigarette_per_day: 0,
      cigarette_by_pack: 0,
      cigarette_pack_price: 0,
      euro_per_month: 0,
      euro_per_years: 0,
      co2_per_years: 0,
      anime: false
    }
  }

  calculate() {
    if (this.state.cigarette_per_day > 0 && this.state.cigarette_by_pack > 0 && this.state.cigarette_pack_price > 0) {
      const priceMonth = 30 * (this.state.cigarette_per_day / this.state.cigarette_by_pack) * this.state.cigarette_pack_price;
      const priceYear = priceMonth * 12;
      const co2 = this.state.cigarette_per_day * kgCo2PerCigarette * 365;

      if (priceMonth !== this.state.euro_per_month || priceYear !== this.state.euro_per_years || co2 !== this.state.co2_per_years) {
        this.setState({
          euro_per_month: Math.round(priceMonth * 100) / 100,
          euro_per_years: Math.round(priceYear * 100) / 100,
          co2_per_years: Math.round(co2 * 100) / 100,
        })
      }

      this.setState({
        anime: true
      })
    }
  }

  render() {
    return (
      <div className="Calculator">
        <div class="Calculator-heading">
          <h2 className="Calculator-title h1-style">Combien pourriez-vous économiser ?</h2>
        </div>
        <div className="Calculator-container">
          <div className="Calculator-content">
            <ul className="Calculator-results">
              <li className="Calculator-result">
                <span className="Calculator-resultValue">{this.state.euro_per_month} €</span>
                <span className="Calculator-resultSublabel"> par mois</span>
              </li>
              <li className="Calculator-result">
                <span className="Calculator-resultValue">{this.state.euro_per_years} €</span>
                <span className="Calculator-resultSublabel"> par an</span>
              </li>
              <li className="Calculator-result">
                <span className="Calculator-resultLabel">Empreinte Carbone</span>
                <span className="Calculator-resultValue">{this.state.co2_per_years} Kg/CO<sub>2</sub></span>
                <span className="Calculator-resultSublabel"> par an</span>
              </li>
            </ul>
            <div className="Calculator-form">
              <div className="Calculator-formItem">
                <label>Nombre de cigarettes par jour</label>
                <InputRange
                  maxValue={60}
                  minValue={0}
                  value={this.state.cigarette_per_day}
                  onChange={cigarette_per_day => this.setState({ cigarette_per_day })}
                  onChangeComplete={cigarette_per_day => this.calculate()}
                />
              </div>
              <div className="Calculator-formItem">
                <label>Nombre de cigarettes dans le paquet</label>
                <div class="Calculator-formRadios">
                  <div class="Calculator-formRadio">
                    <input type="radio" id={'cigarettesByPack20'} value="20" name={'cigarettesByPack'}
                    onClick={event => this.setState({ cigarette_by_pack: event.target.value }, () => this.calculate())} />
                    <label htmlFor="cigarettesByPack20">20</label>
                  </div>
                  <div class="Calculator-formRadio">
                    <input type="radio" id={'cigarettesByPack25'} value="25" name={'cigarettesByPack'}
                    onClick={event => this.setState({ cigarette_by_pack: event.target.value }, () => this.calculate())} />
                    <label htmlFor="cigarettesByPack25">25</label>
                  </div>
                  <div class="Calculator-formRadio">
                    <input type="radio" id={'cigarettesByPack30'} value="30" name={'cigarettesByPack'}
                    onClick={event => this.setState({ cigarette_by_pack: event.target.value }, () => this.calculate())} />
                    <label htmlFor="cigarettesByPack30">30</label>
                  </div>
                </div>
              </div>
              <div className="Calculator-formItem Calculator-formItem--price">
                <label>Prix du paquet</label>
                <InputRange
                  maxValue={200}
                  minValue={0}
                  step={1}
                  value={Math.round(this.state.cigarette_pack_price * 10)}
                  formatLabel={value => `${(value / 10).toFixed(1)}`}
                  onChange={value => this.setState({ cigarette_pack_price: value / 10 })}
                  onChangeComplete={() => this.calculate()}
                />
              </div>
            </div>
          </div>
          <div className={"Calculator-images" + (this.state.anime ? ' Calculator-images--animated' : '') }>
            <img src="assets/build/images/calculator.png" alt="" className="Calculator-image--static" width={150} height={218.43} />
            <img src="assets/build/images/calculator-anime.gif" alt="" className="Calculator-image--anime" width={150} height={218.43} />
          </div>
        </div>
      </div>
    )
  }
}

export default Calculator;
